// extracted by mini-css-extract-plugin
export default {"root":"_1sI3U","fill":"_22T2L _1sI3U","stroke":"ANu-V _1sI3U","action":"_1bw9g","radioOutline":"_1QGoB _1sI3U","addCircle":"_3jB0r _1sI3U","lock":"_2Q3AT"};